import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    { path: '/', component: () => import('../pages/ConvocationLandingPage.vue') },
    { path: '/payment', component: () => import('../pages/ConvocationPaymentPage.vue') },
    { path: '*', redirect: '/' },
  ],
});
